import React from 'react';
import GridTable from '../../components/GridTable';
import Layout from '../../components/Layout';
import { MODULES } from '../../utils/constants';
import AddUserDialog from './AddUserDialog';
import { getColumns } from './constants';
import { useUserStore } from '../../services/user';
import { useCompanyStore } from '../../services/company';
import { useAppContext } from '../../services/context/AppContext';
import { getUserCorporateId, hasRole, isHRUser } from '../../utils/helper';

const Users = () => {
    const {
        data,
        totalPages,
        currentPage,
        total,
        rows,
        isLoading,
        onPageChange,
        onDelete,
        setFilters,
    } = useUserStore();
    const { globalCompanyId } = useCompanyStore();
    const { userData } = useAppContext();
    const isHR = isHRUser(userData);
    const hrCorporateId = getUserCorporateId(userData);

    React.useEffect(() => {
        if (isHR && hrCorporateId) {
            setFilters({ corporateId: hrCorporateId } as any);
            return;
        }

        if (!globalCompanyId || globalCompanyId === "general") {
            setFilters({} as any);
        } else {
            // Corporate scope: filter users by corporateId
            setFilters({ corporateId: globalCompanyId } as any);
        }
    }, [globalCompanyId, hrCorporateId, isHR, setFilters]);

    return (
        <Layout appBarTitle="User Management">
            <Layout.Header component={AddUserDialog} props={{ module: MODULES.USER, showDeletedUsers: hasRole(userData?.role, MODULES.ADMIN) }} />
            <Layout.Body
                component={GridTable}
                props={{
                    data,
                    columns: getColumns(currentPage, rows),
                    currentPage,
                    totalPages,
                    total,
                    loading: isLoading,
                    onPageChange,
                    module: MODULES.USER,
                    onDelete: (item: any) => onDelete(item._id),
                    rows
                }}
            />
        </Layout>
    );
};

export default Users;
